import { ReactElement, useCallback } from 'react';

import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { Translate } from '@dreryk/react-common';
import { Dropdown, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type AppointmentTermUpdateDropdownItemProps = {
   readonly appointmentId: VisitAndAppointmentView['appointmentId'];
};
export const AppointmentTermUpdateDropdownItem = (props: AppointmentTermUpdateDropdownItemProps): ReactElement => {
   const push = useHistoryPushWithBackAction(true);
   const creatingAppointmentsAvailable = protectFeature('creatingAppointments');

   const goToCalendar = useCallback(
      (hide) => {
         push(
            visitPaths.getCalendarPath({
               searchParams: {
                  updateTermAppointmentId: props.appointmentId,
               },
            }),
            { label: visitTranslationKeys.goBackToAppointmentsList }
         );
         hide();
      },
      [push, props.appointmentId]
   );

   return (
      <Dropdown.Item
         testId={`appointmentTermUpdateOption${props.appointmentId}`}
         disabled={!creatingAppointmentsAvailable}
         onClick={goToCalendar}
      >
         <Dropdown.Item.Tooltip
            testId={'updateTerm'}
            content={appointmentsTranslationKeys.accountPartiallyBlocked}
            disabled={creatingAppointmentsAvailable}
         >
            <Translate>{appointmentsTranslationKeys.updateTerm}</Translate>
         </Dropdown.Item.Tooltip>
      </Dropdown.Item>
   );
};
